
import { Card, CardActionArea, CardMedia, Typography, Box, Stack } from "@mui/material";
import { getAvailableItems } from '../services/item.js';
import dayjs from 'dayjs';
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { removeUserAction } from '../actions/profile.js';

const FrequentProducts = ({ products = [], items, selectedItems, setSelectedItems, fromDate, toDate }) => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    
        const handleSelect = async (product) => {
            const value = items.find(item => item._id === product.productId)
            if (value) {
                value.count = 1;
                const index = selectedItems.findIndex(selItem =>selItem._id === value._id)
                if (index < 0) {
                  try {
                    value.availableItems = await getAvailableItems(dayjs(fromDate).format('YYYY-MM-DD HH:mm'), dayjs(toDate).format('YYYY-MM-DD HH:mm'), value._id)
                    value.availableItems = value.availableItems.map(_ => ({..._, rent: value.rent}))                
                    value.items = [value.availableItems[0]]
                    const _selectedItems = [...selectedItems, value]
                    setSelectedItems(_selectedItems)
                  } catch (e) {
                    if (e.status === 401) {
                        dispatch(removeUserAction())
                        navigate('/');
                    }
                  }
                }
            }
        }

    return (
        <Box
            sx={{
                maxHeight: 300,
                overflowY: "auto",
                display: "grid",
                gridTemplateColumns: "repeat(auto-fill, minmax(120px, 1fr))",
                gap: 1.5,
                p: 1
            }}
        >
            {products.map((product) => {
                const isAvailable = items.find(item => item._id === product.productId)
                return (
                    <Card
                        key={product._id}
                        sx={{
                            minWidth: 120,
                            borderRadius: 3,
                            flexShrink: 0
                        }}
                    >
                        <CardActionArea sx={isAvailable ? {opacity: 1, cursor: 'pointer'} : {opacity: 0.4, cursor: 'not-allowed'}}onClick={() => {if (isAvailable) {handleSelect(product)}}}>
                            <Stack direction="row">
                                <CardMedia
                            component="img"
                            height="60"
                            image={product.image.thumb}
                            alt={product.name}
                            sx={{ objectFit: "contain" }}
                        />
                        <Box sx={{ p: 1 }}>
                            <Typography
                                variant="caption"
                                sx={{
                                    fontWeight: 500,
                                    display: "block",
                                    textAlign: "center",
                                    wordBreak: "break-all" 
                                }}
                            >
                                {product.name}
                            </Typography>
                        </Box>
                            </Stack>
                    

                    
                        </CardActionArea>
                    </Card>
                )
            })}
        </Box>
    );
}

export default FrequentProducts